<template>
    <div class="d-flex flex-column gap-3">
        <OrderRefundCard
            v-for="orderRefund in order.refunds"
            :key="orderRefund.id"
            :order-refund="orderRefund"
            :store="store"
            :order="order"
        />
    </div>
</template>

<script>
import OrderRefundCard from "./OrderRefundCard.vue";

export default {
    components: {OrderRefundCard},

    props: {
        order: Object,
        store: Object
    },

    computed: {
        unprocessedRefunds() {
            let refunds = [];
            for (let refund of this.order.refunds) {
                if (!refund.effective) {
                    refunds.push(refund);
                }
            }
            return refunds;
        }
    }
}
</script>
